import { render } from "./slide6.vue?vue&type=template&id=40957422"
import script from "./slide6.vue?vue&type=script&lang=js"
export * from "./slide6.vue?vue&type=script&lang=js"

import "./slide6.vue?vue&type=style&index=0&id=40957422&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__